import { render } from "./App.vue?vue&type=template&id=0fa8951c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0fa8951c&lang=css"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__